<template>
	<div class="app-management-container">
		<div class="container-title">应用管理</div>
		<div class="app-box">
			<div class="app-item" v-for="app in apps" :key="app.title">
				<img :src="app.img" />
				<span class="app-item-title"> {{ app.title }} </span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			apps: [
				{
					img:
						'http://10.88.18.212:8080/%e8%96%aa%e7%81%ab%e7%be%8e%e8%82%b21.1.1/images/%E5%BA%94%E7%94%A8%E7%AE%A1%E7%90%86/u35759.png',
					title: '授课系统'
				}
			]
		}
	}
}
</script>

<style lang="scss" scpoed>
.app-management-container {
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: #fff;
	min-height: inherit;
}
.container-title {
	padding: 20px;
	font-size: 18px;
	color: #030303;
}
.app-box {
	display: flex;
	align-items: center;
	padding: 0 20px;
}

.app-item {
	display: flex;
	align-items: center;
	width: 240px;
	height: 100px;
	border-radius: 10px;
	border: 1px solid #e9e9e9;
	background: #fbfbfb;
	padding: 30px;
	box-sizing: border-box;
	.app-item-title {
		padding-left: 20px;
	}
}
</style>
